export default "/images/vendor/flag-icon-css/flags/4x3/cc.svg?200233c98efe5d026e98498cf8969844";